<div class="permit-result" [class.permit-result--issued]="issued" [class.permit-result--pending]="!issued">
    <p class="permit-result__status"><i class="fa me-2" [class.fa-circle-check]="issued" [class.fa-clock]="!issued" aria-hidden="true"></i>{{ heading }}</p>

    <!-- The permit number is deliberately not shown here (TLC, 18 Sep): it reaches the
         applicant only on the issued PDF, never on-screen, so it can't be screenshot in
         place of the permit. The download button below is how they get the real thing. -->
    <p class="permit-result__meta">
        @if (issued) {
            <!-- Auto-issued path (TLC, 29 Sep): the permit exists and has been emailed. -->
            Your permit has been sent to {{ email || 'your email address' }}.
            @if (partySize && partySize > 1) {
                Covers {{ partySize }} people.
            }
        } @else {
            @if (partySize && partySize > 1) {
                Covers {{ partySize }} people &middot;
            }
            Sent to {{ email || 'your email address' }}
        }
    </p>

    @if (body || defaultBody) {
        <p class="permit-result__body">{{ body || defaultBody }}</p>
    }

    <div class="permit-result__actions">
        <ng-content></ng-content>
    </div>
</div>
